import { lazy } from "react";

// Login and registration
const Login = lazy(() => import("../pages/user-management/login/Login"));
const Registration = lazy(
  () => import("../pages/user-management/registration/Registration")
);
const CreateUser = lazy(
  () => import("../pages/user-management/create-user/CreateUser")
);
const AlreadyUserExist = lazy(
  () => import("../pages/already-user-exist/AlreadyUserExist")
);

// home
const HomeContainer = lazy(() => import("../pages/home/HomeContainer"));
const Home = lazy(() => import("../pages/home/Home"));
const ViewPost = lazy(() => import("../pages/home/view-post/ViewPost"));
const Upload = lazy(() => import("../pages/upload/Upload"));

// profile & selfProfile
const SelfProfile = lazy(() => import("../pages/self-profile/SelfProfile"));
const EditProfile = lazy(
  () => import("../pages/self-profile/edit-profile/EditProfile")
);
const Favourites = lazy(
  () => import("../pages/self-profile/favourites/Favourites")
);

// Notification
const Notifications = lazy(
  () => import("../pages/notifications/Notifications")
);

// Explore
const Explore = lazy(() => import("../pages/explore/Explore"));

// Search
const Search = lazy(() => import("../pages/search/Search"));

// Blogs
const Blogs = lazy(() => import("../pages/blogs/Blogs"));

// Create-post
const CreatePost = lazy(() => import("../pages/create-post/CreatePost"));
const PreviewPost = lazy(
  () => import("../pages/create-post/preview-post/PreviewPost")
);
const AddPostDetails = lazy(
  () => import("../pages/create-post/addPostDescription/AddPostDetails")
);
const PostReorder = lazy(
  () => import("../pages/create-post/post-reorder/PostReorder")
);

// Create-project
const CreateProject = lazy(
  () => import("../pages/create-project/CreateProject")
);
const ArtistDetails = lazy(
  () =>
    import("../pages/create-project/collaborators/artist-details/ArtistDetails")
);
const TermsAndConditions = lazy(
  () =>
    import("../pages/create-project/terms-and-conditions/TermsAndConditions")
);
const PreviewProject = lazy(
  () => import("../pages/create-project/preview-project/PreviewProject")
);

// Dashboard
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const MyProjects = lazy(
  () => import("../pages/dashboard/my-projects/MyProjects")
);
const MyCollaborators = lazy(
  () => import("../pages/dashboard/my-collabrorators/MyCollaborators")
);
const MyCalender = lazy(
  () => import("../pages/dashboard/my-calender/MyCalender")
);
const ProjectDetails = lazy(
  () => import("../pages/dashboard/project-details/ProjectDetails")
);
const AskToCollaborate = lazy(
  () =>
    import(
      "../pages/dashboard/project-details/ask-to-collaborate/AskToCollaborate"
    )
);
const ProjectOwnerView = lazy(
  () =>
    import(
      "../pages/dashboard/project-details/view-all-collaborators/ProjectOwnerView"
    )
);
const InviteMoreCollaborator = lazy(
  () =>
    import(
      "../pages/dashboard/project-details/invite-more-collaborator/InviteMoreCollaborator"
    )
);
const PreviewTask = lazy(
  () =>
    import(
      "../pages/dashboard/my-calender/project-tasks/preview-task/PreviewTask"
    )
);
const CreateTask = lazy(
  () =>
    import(
      "../pages/dashboard/my-calender/project-tasks/create-task/CreateTask"
    )
);
const CollaboratorView = lazy(
  () =>
    import(
      "../pages/dashboard/project-details/view-all-collaborators/CollaboratorView"
    )
);
const RequestNegotiation = lazy(
  () =>
    import(
      "../pages/dashboard/project-details/request-negotiation/RequestNegotiation"
    )
);
const ApplyProject = lazy(
  () => import("../pages/explore/apply-project/ApplyProject")
);
const MediaGallery = lazy(
  () => import("../pages/dashboard/project-details/media-gallery/MediaGallery")
);
const SketchBoard = lazy(
  () =>
    import("../pages/dashboard/project-details/scribble-board/ScribbleBoard")
);
const ProjectReportFlow = lazy(
  () => import("../pages/create-project/project-report-flow/ProjectReportFlow")
);
const ProjectEndingFlow = lazy(
  () => import("../pages/create-project/project-ending-flow/ProjectEndingFlow")
);

// Help and support
const HelpAndSupport = lazy(
  () => import("../pages/help-and-support/HelpAndSupport")
);
const Help = lazy(() => import("../pages/help-and-support/help/Help"));
const HelpCentre = lazy(
  () => import("../pages/help-and-support/help/help-center/HelpCentre")
);
const ReportProblem = lazy(
  () => import("../pages/help-and-support/help/report-problem/ReportProblem")
);
const Legal = lazy(() => import("../pages/help-and-support/help/legal/Legal"));
const Faqs = lazy(() => import("../pages/help-and-support/help/faqs/Faqs"));
const SupportRequests = lazy(
  () =>
    import("../pages/help-and-support/help/support-requests/SupportRequests")
);
const ProfileSecurityMobileView = lazy(
  () =>
    import(
      "../pages/help-and-support/profile-security/ProfileSecurityMobileView"
    )
);
const LoginActivity = lazy(
  () =>
    import(
      "../pages/help-and-support/profile-security/login-activity/LoginActivity"
    )
);
const LoginCredentials = lazy(
  () =>
    import(
      "../pages/help-and-support/profile-security/login-credentials/LoginCredentials"
    )
);
const NotificationSettings = lazy(
  () =>
    import(
      "../pages/help-and-support/notification-settings/NotificationSettings"
    )
);

// chats
const Chats = lazy(() => import("../pages/chats/Chats"));

export const pageRoutes = {
  // login and registration
  Registration,
  CreateUser,
  Login,
  AlreadyUserExist,

  // home
  HomeContainer,
  Home,
  ViewPost,
  Upload,

  // Blogs
  Blogs,

  // profile & selfProfile
  SelfProfile,
  EditProfile,
  Favourites,

  // profile & selfProfile
  Notifications,

  // Search
  Search,

  // Explore
  Explore,

  // Create-project
  CreateProject,
  ArtistDetails,
  TermsAndConditions,
  PreviewProject,

  // Create-post
  CreatePost,
  PreviewPost,
  PostReorder,
  AddPostDetails,

  // Help and Support
  HelpAndSupport,
  Help,
  HelpCentre,
  ReportProblem,
  Legal,
  Faqs,
  SupportRequests,
  ProfileSecurityMobileView,
  LoginActivity,
  LoginCredentials,
  NotificationSettings,

  // Dashboard
  MyCalender,
  Dashboard,
  MyProjects,
  MyCollaborators,
  ProjectDetails,
  AskToCollaborate,
  ProjectOwnerView,
  InviteMoreCollaborator,
  PreviewTask,
  CreateTask,
  CollaboratorView,
  RequestNegotiation,
  ApplyProject,
  SketchBoard,
  MediaGallery,
  ProjectEndingFlow,
  ProjectReportFlow,
  Chats,
};
